export default class CustomerImportJob {
    constructor() {
        this.id;
        this.createdByUserId;
        this.createdAt;
        this.importFileId;
        this.parseResultFileId;
        this.parseIsSuccess;
        this.parseDate;
        this.identityResultFileId;
        this.identityIsSuccess;
        this.identityDate;
        this.customerResultFileId;
        this.customerIsSuccess;
        this.customerDate;
        this.customerDepenResultFileId;
        this.customerDepenIsSuccess;
        this.customerDepenDate;
        this.userAccisureRepId;
        this.customerCompanyId;
        this.representativeId;
        this.subscriptionId;
        this.debitOrderDate;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.createdByUserId = setEntity.createdByUserId;
        this.createdAt = setEntity.createdAt;
        this.importFileId = setEntity.importFileId;
        this.parseResultFileId = setEntity.parseResultFileId;
        this.parseIsSuccess = setEntity.parseIsSuccess;
        this.parseDate = setEntity.parseDate;
        this.identityResultFileId = setEntity.identityResultFileId;
        this.identityIsSuccess = setEntity.identityIsSuccess;
        this.identityDate = setEntity.identityDate;
        this.customerResultFileId = setEntity.customerResultFileId;
        this.customerIsSuccess = setEntity.customerIsSuccess;
        this.customerDate = setEntity.customerDate;
        this.customerDepenResultFileId = setEntity.customerDepenResultFileId;
        this.customerDepenIsSuccess = setEntity.customerDepenIsSuccess;
        this.customerDepenDate = setEntity.customerDepenDate;
        this.userAccisureRepId = setEntity.userAccisureRepId;
        this.customerCompanyId = setEntity.customerCompanyId;
        this.representativeId = setEntity.representativeId;
        this.subscriptionId = setEntity.subscriptionId;
        this.debitOrderDate = setEntity.debitOrderDate;
        return this;
    }
}
